/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-a26b9c60.mjs';
import { isVNode, defineComponent, toRefs, inject, ref, computed, onMounted, createVNode, getCurrentInstance } from 'vue';
import props from './menu-item-props.mjs';
import { renderTNodeJSX, renderContent } from '../utils/render-tnode.mjs';
import { emitEvent } from '../utils/event.mjs';
import useRipple from '../hooks/useRipple.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { Tooltip } from '../tooltip/index.mjs';
import '../_chunks/dep-b333ab93.mjs';
import '../_chunks/dep-ec227f3f.mjs';
import '../_chunks/dep-6f3e4f56.mjs';
import '../_chunks/dep-18bb982b.mjs';
import '../_chunks/dep-25d66c95.mjs';
import '../_chunks/dep-b1060562.mjs';
import '../_chunks/dep-372265bb.mjs';
import '../_chunks/dep-97c71289.mjs';
import '../_chunks/dep-4efc69ee.mjs';
import '../_chunks/dep-ae08d6c4.mjs';
import '../_chunks/dep-8049d2e0.mjs';
import '../_chunks/dep-d940e2da.mjs';
import '../_chunks/dep-e50fa7b0.mjs';
import '../_chunks/dep-c57d8117.mjs';
import '../_chunks/dep-c7e4942d.mjs';
import '../_chunks/dep-0d1bd08c.mjs';
import '../_chunks/dep-c5d88cfe.mjs';
import '../_chunks/dep-5f6c8826.mjs';
import '../_chunks/dep-0a6fd248.mjs';
import '../_chunks/dep-7ad89920.mjs';
import '../_chunks/dep-36563716.mjs';
import '../_chunks/dep-b1013215.mjs';
import '../_chunks/dep-91fc304f.mjs';
import '../_chunks/dep-17446155.mjs';
import '../_chunks/dep-8747fcf0.mjs';
import '../utils/helper.mjs';
import '../_chunks/dep-9c7a32ff.mjs';
import '../_chunks/dep-89b33ff6.mjs';
import '../_chunks/dep-6bcce672.mjs';
import '../_chunks/dep-ce88e3c0.mjs';
import '../_chunks/dep-c45cdd10.mjs';
import '../_chunks/dep-a432d90f.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../_chunks/dep-3a045465.mjs';
import '../_chunks/dep-77f634fb.mjs';
import '../_chunks/dep-28ae3cda.mjs';
import '../_chunks/dep-7211604f.mjs';
import '../_chunks/dep-75df64b1.mjs';
import '../_chunks/dep-48b9a098.mjs';
import '../_chunks/dep-52c1d6a9.mjs';
import '../_chunks/dep-53dc0ac1.mjs';
import '../_chunks/dep-b6b4eaa3.mjs';
import '../_chunks/dep-881cffb7.mjs';
import '../_chunks/dep-436b338d.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-2d31a683.mjs';
import '../_chunks/dep-3ddc95d0.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-493c38ce.mjs';
import '../_chunks/dep-b56b2dc0.mjs';
import '../_chunks/dep-6043e9fc.mjs';
import '../config-provider/type.mjs';
import '../utils/set-style.mjs';
import '../tooltip/tooltip.mjs';
import '../_chunks/dep-7cc8d2c3.mjs';
import '../_chunks/dep-6e04bcaa.mjs';
import '../_chunks/dep-d23f3733.mjs';
import '../_chunks/dep-4b3e18ca.mjs';
import '../tooltip/props.mjs';
import '../popup/props.mjs';
import '../popup/index.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../_chunks/dep-9239b808.mjs';
import '../_chunks/dep-8bda6dda.mjs';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../hooks/tnode.mjs';
import '../hooks/useCommonClassName.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../hooks/useVModel.mjs';
import '../hooks/useImagePreviewUrl.mjs';
import '../_common/js/upload/utils.mjs';
import '../_common/js/log/log.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../_common/js/utils/set-style.mjs';
import '../popup/container.mjs';
import '../_chunks/dep-f7837681.mjs';
import '../hooks/useResizeObserver.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../popup/type.mjs';
import '../tooltip/util.mjs';
import '../tooltip/type.mjs';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !isVNode(s);
}
var _MenuItem = defineComponent({
  name: "TMenuItem",
  props: _objectSpread({}, props),
  emits: ["click"],
  setup: function setup(props2, ctx) {
    var _toRefs = toRefs(props2),
      href = _toRefs.href,
      target = _toRefs.target;
    var classPrefix = usePrefixClass();
    var menu = inject("TdMenu");
    var itemRef = ref();
    useRipple(itemRef);
    var submenu = inject("TdSubmenu", null);
    var active = computed(function () {
      return menu.activeValue.value === props2.value;
    });
    var collapsed = computed(function () {
      var _menu$collapsed;
      return (_menu$collapsed = menu.collapsed) === null || _menu$collapsed === void 0 ? void 0 : _menu$collapsed.value;
    });
    var classes = computed(function () {
      return ["".concat(classPrefix.value, "-menu__item"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(classPrefix.value, "-is-active"), active.value), "".concat(classPrefix.value, "-is-disabled"), props2.disabled), "".concat(classPrefix.value, "-menu__item--plain"), !ctx.slots.icon && !props2.icon), "".concat(classPrefix.value, "-submenu__item"), !!submenu && !menu.isHead)];
    });
    onMounted(function () {
      var _menu$vMenu;
      menu === null || menu === void 0 || (_menu$vMenu = menu.vMenu) === null || _menu$vMenu === void 0 || _menu$vMenu.add(_objectSpread({
        value: props2.value,
        parent: submenu === null || submenu === void 0 ? void 0 : submenu.value,
        vnode: ctx.slots["default"]
      }, props2));
    });
    return {
      classPrefix: classPrefix,
      menu: menu,
      active: active,
      collapsed: collapsed,
      classes: classes,
      itemRef: itemRef,
      href: href,
      target: target,
      submenu: submenu
    };
  },
  methods: {
    handleClick: function handleClick(e) {
      var _this$submenu, _this$submenu$closePa;
      e.stopPropagation();
      if (this.disabled) return;
      this.menu.select(this.value);
      emitEvent(this, "click", {
        e: e,
        value: this.value
      });
      if (this.to || this.routerLink && this.href) {
        var router = this.router || this.$router;
        var methods = this.replace ? "replace" : "push";
        router[methods](this.to || this.href)["catch"](function (err) {
          if (err.name !== "NavigationDuplicated" && !err.message.includes("Avoided redundant navigation to current location")) {
            throw err;
          }
        });
      }
      (_this$submenu = this.submenu) === null || _this$submenu === void 0 || (_this$submenu$closePa = _this$submenu.closeParentPopup) === null || _this$submenu$closePa === void 0 || _this$submenu$closePa.call(_this$submenu, e);
    }
  },
  render: function render() {
    var _this = this;
    var router = this.router || this.$router;
    var liContent = createVNode("li", {
      "ref": "itemRef",
      "class": this.classes,
      "onClick": this.handleClick
    }, [renderTNodeJSX(this, "icon"), this.routerLink ? createVNode("a", {
      "href": this.href ? this.href : this.to ? router === null || router === void 0 ? void 0 : router.resolve(this.to).href : "",
      "target": this.target,
      "class": "".concat(this.classPrefix, "-menu__item-link"),
      "onClick": function onClick(e) {
        return e.preventDefault();
      }
    }, [createVNode("span", {
      "class": "".concat(this.classPrefix, "-menu__content")
    }, [renderContent(this, "default", "content")])]) : this.href ? createVNode("a", {
      "href": this.href,
      "target": this.target,
      "class": "".concat(this.classPrefix, "-menu__item-link"),
      "onClick": function onClick(e) {
        return _this.disabled && e.preventDefault();
      }
    }, [createVNode("span", {
      "class": "".concat(this.classPrefix, "-menu__content")
    }, [renderContent(this, "default", "content")])]) : createVNode("span", {
      "class": "".concat(this.classPrefix, "-menu__content")
    }, [renderContent(this, "default", "content")])]);
    var instance = getCurrentInstance();
    var node = instance.parent;
    if (this.collapsed && /tmenu/i.test(node === null || node === void 0 ? void 0 : node.type.name)) {
      return createVNode(Tooltip, {
        "content": function content() {
          return renderContent(_this, "default", "content");
        },
        "placement": "right"
      }, _isSlot(liContent) ? liContent : {
        "default": function _default() {
          return [liContent];
        }
      });
    }
    return liContent;
  }
});

export { _MenuItem as default };
//# sourceMappingURL=menu-item.mjs.map
